'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cookieNames = require('../configs/cookieNames.js');

var _cookies = require('dna-core/lib/utils/js/cookies');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CookieInMemoryApi = function () {
    function CookieInMemoryApi(cookies) {
        _classCallCheck(this, CookieInMemoryApi);

        this._cookies = new _cookies.Cookies(_cookieNames.COOKIE_NAMES.JG_ANALYTICS_COOKIE_NAME, cookies);
    }

    _createClass(CookieInMemoryApi, [{
        key: 'getAnalyticsCookie',
        value: function getAnalyticsCookie() {
            return this._cookies.analyticsCookie;
        }
    }, {
        key: 'getAbCookie',
        value: function getAbCookie() {
            return this._cookies.JgAbLoggedInCookie.value;
        }
    }, {
        key: 'getKissmetricsCookie',
        value: function getKissmetricsCookie() {
            return this._cookies.cookies.km_ai;
        }
    }, {
        key: 'getCookieString',
        value: function getCookieString() {
            return this._cookies.cookiesSource;
        }
    }, {
        key: 'getAuthUserEmail',
        value: function getAuthUserEmail(envCookieName) {
            return this._cookies.cookieToObject(envCookieName).Email;
        }
    }, {
        key: 'getKOALAEmailIdentity',
        value: function getKOALAEmailIdentity() {
            return this._cookies.cookies[_cookieNames.COOKIE_NAMES.KOALA_EmailIdentity];
        }

        //TODO Feature: Node how to pass the cookies back

    }, {
        key: 'setAnalyticsCookie',
        value: function setAnalyticsCookie(logged_out_cookie, logged_in_cookie) {}
    }, {
        key: 'setKOALAEmailIdentity',
        value: function setKOALAEmailIdentity(email) {}
    }, {
        key: 'setCookie',
        value: function setCookie(name, value) {}
    }]);

    return CookieInMemoryApi;
}();

exports.default = CookieInMemoryApi;


// WEBPACK FOOTER //
// ../~/@jg/koala-front-end-analytics/lib/lib/cookieInMemoryApi.js